/** Plain-language names for stall causes (daemon `StallCause`); unknown causes get no label. */
const STALL_REASON: Record<string, string> = {
  permission_denied: 'A command needed a permission the agent does not have',
  tcc_denied: 'macOS blocked access (a privacy permission is missing)',
  auth_expired: "The agent's sign-in expired",
  op_locked: '1Password is locked',
  rate_limited: 'The usage limit is reached',
  ci_credits: 'CI is out of credits',
  disk_full: 'The disk is full',
  file_locked: 'A file is locked by another process',
  sandbox_denied: 'The sandbox refused an action',
  no_output: 'The run stopped producing output',
}

export function stallReason(cause: string | undefined): string | undefined {
  if (!cause) return undefined
  return STALL_REASON[cause.replace(/^stall:/, '')]
}

/** The hub's placeholder title for an opaque (encrypted) blocker. */
export const SCHEDULE_OPAQUE_TITLE = 'details are in the machine report'
